import { render, staticRenderFns } from "./registerInChain.vue?vue&type=template&id=30751acc"
import script from "./registerInChain.vue?vue&type=script&lang=js"
export * from "./registerInChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports